import React from 'react';
import { JsonFormatter } from '../components/json-formatter/JsonFormatter';
import '../components/json-formatter/JsonFormatter.css';

export const JsonFormatterPage: React.FC = () => {
  return (
    <div className="page-container">
      <JsonFormatter />
    </div>
  );
};
